
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiElectricGenerator as ObiElectricGeneratorElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-electric-generator.js';
 
 
 

 
 export const ObiElectricGenerator = createComponent({
   react: React,
   tagName: 'obi-electric-generator',
   elementClass: ObiElectricGeneratorElement,
   events: {
     
   }
  });
 
 